"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesMapSearch = void 0;
const pick_1 = __importDefault(require("lodash/pick"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const fdr_agency_autocomplete_field_1 = require("./fdr-agency-autocomplete-field");
const fdr_agency_map_search_styles_1 = require("./fdr-agency-map-search.styles");
const AROUND_MY_LOCATION_ZOOM = 10;
var PositionErrors;
(function (PositionErrors) {
    PositionErrors[PositionErrors["PERMISSION_DENIED"] = 1] = "PERMISSION_DENIED";
    PositionErrors[PositionErrors["POSITION_UNAVAILABLE"] = 2] = "POSITION_UNAVAILABLE";
    PositionErrors[PositionErrors["TIMEOUT"] = 3] = "TIMEOUT";
})(PositionErrors || (PositionErrors = {}));
const AgenciesMapSearch = props => {
    const { children, map, autocompleteDataSource, searchAroundMe = true, setUserLocation, className, } = props;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const [t] = (0, next_i18next_1.useTranslation)('agency');
    const [selected, setSelected] = (0, react_1.useState)(undefined);
    const [isNavigatorExist, setIsNavigatorExist] = (0, react_1.useState)(false);
    const [locationError, setLocationError] = (0, react_1.useState)(undefined);
    function retrieveGeoPosition(onSuccess) {
        if (typeof navigator !== 'object' || !navigator.geolocation)
            return;
        // Clear error
        setLocationError(undefined);
        function success(position) {
            const { latitude, longitude } = position.coords;
            if (typeof setUserLocation === 'function') {
                setUserLocation({ latitude, longitude });
            }
            setSelected(undefined);
            map === null || map === void 0 ? void 0 : map.setCenter(new google.maps.LatLng(latitude, longitude));
            map === null || map === void 0 ? void 0 : map.setZoom(AROUND_MY_LOCATION_ZOOM);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
        function failure(positionError) {
            switch (positionError.code) {
                case PositionErrors.PERMISSION_DENIED: {
                    setLocationError(t('agency:location.error.permission'));
                    break;
                }
                case PositionErrors.POSITION_UNAVAILABLE: {
                    setLocationError(t('agency:location.error.unavailable'));
                    break;
                }
                case PositionErrors.TIMEOUT: {
                    setLocationError(t('agency:location.error.timeout'));
                    break;
                }
                default: {
                    setLocationError(positionError.message || t('agency:location.error.unexpected'));
                }
            }
            // eslint-disable-next-line no-console
            console.error('PositionError', positionError.code, positionError.message);
        }
        navigator.geolocation.getCurrentPosition(success, failure);
    }
    function selectChange(next) {
        setSelected(next);
        if (typeof setUserLocation === 'function') {
            setUserLocation(next ? (0, pick_1.default)(next.coordinates, ['longitude', 'latitude']) : undefined);
        }
    }
    const locationErrorEl = locationError ? (react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: e => e, error: locationError })) : null;
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined' && typeof navigator === 'object') {
            setIsNavigatorExist(true);
        }
    }, []);
    return (react_1.default.createElement(fdr_agency_map_search_styles_1.AgenciesMapSearchWrapper, { "data-id": "agencies-map-wrapper", className: className },
        react_1.default.createElement("div", null, children),
        react_1.default.createElement(fdr_agency_map_search_styles_1.AgenciesMapSearchBox, { "data-id": "agencies-search-form" },
            react_1.default.createElement("div", { className: "map-search-controls" },
                react_1.default.createElement(fdr_agency_autocomplete_field_1.AgenciesAutocompleteField, { map: map, selected: selected, onChange: selectChange, onSearchAroundMe: searchAroundMe
                        ? onSuccess => retrieveGeoPosition(onSuccess)
                        : undefined, autocompleteDataSource: autocompleteDataSource }, mobile && locationErrorEl)),
            searchAroundMe &&
                !mobile &&
                isNavigatorExist &&
                navigator.geolocation ? (react_1.default.createElement(fdr_agency_map_search_styles_1.AgenciesMapSearchGeo, null,
                react_1.default.createElement(fdr_agency_map_search_styles_1.AroundMeButton, { variant: "linkBtn", testId: "around-me-btn", icon: {
                        name: 'aroundme',
                        size: 'lg',
                    }, onClick: () => retrieveGeoPosition() }, t('agency:search.aroundMe')),
                locationErrorEl)) : null)));
};
exports.AgenciesMapSearch = AgenciesMapSearch;
//# sourceMappingURL=fdr-agency-map-search.js.map